export default "__VITE_ASSET__Banbn8Sx__"